import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MeService } from '../../services/me.service';

@Component({
  selector: 'sheet-application-install',
  templateUrl: './sheet-application-install.component.html',
  styleUrls: ['./sheet-application-install.component.css'],
  imports: []
})
export class SheetApplicationInstallComponent implements OnInit {

  public get msg(): any { return this.me.msg.app.install; }
  public get text(): any { return this.me.texts.components['sheet-application-install']; }

  constructor(public me: MeService,
    private _bottomSheetRef: MatBottomSheetRef<SheetApplicationInstallComponent>) { }

  ngOnInit() {

  }

  close(event: MouseEvent | undefined = undefined): void {

    this._bottomSheetRef.dismiss();

    if (event)
      event.preventDefault();

  }







}
